import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import Swal from 'sweetalert2';
import ReactCardFlip from "react-card-flip";

function Home() {
  const [title, setTitle] = useState("ConnectKGP");
  const [isSignIn, setIsSignIn] = useState(false);
  const [waiting, setWaiting] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [signinFormData, setSigninFormData] = useState({
    email: '',
    password: '',
  });
  
  const serverHost = process.env.REACT_APP_SERVER_HOST;
  
  const [signupFormData, setSignupFormData] = useState({
    email: '',
    password: '',
    name: '',
  });

  const navigate = useNavigate();

  const toggleForm = () => {
    setIsSignIn(!isSignIn);
  };

  const validateToken = async (access_token) => {
    const response = await fetch(`${serverHost}/verify-token?access_token=${access_token}`, { method: 'GET' });
    const result = await response.json();

    if (response.status === 200) {
      sessionStorage.setItem('user_id', result.user_id);
      sessionStorage.setItem('username', result.username);
      sessionStorage.setItem('icon', result.icon);
      navigateTo('/dashboard');
    } else {
      localStorage.removeItem('ss_token');
    }
  };

  const hackTitle = () => {
    const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const finalText = "ConnectKGP";
    let iteration = 0;
    let interval = null;
  
    clearInterval(interval);
    interval = setInterval(() => {
      setTitle(prevTitle => {
        return finalText
          .split("")
          .map((letter, index) => {
            if (index < iteration) {
              return finalText[index];
            }
            return letters[Math.floor(Math.random() * letters.length)];
          })
          .join("");
      });
  
      if (iteration >= finalText.length) {
        clearInterval(interval);
      }
  
      iteration += 1 / 3;
    }, 30);
  };

  useEffect(() => {
    const user_email = localStorage.getItem('ck_user_email');
    const access_token = localStorage.getItem('ss_token');
    if (access_token) {
      validateToken(access_token);
    }
    if (user_email) {
      setIsSignIn(true);
      setSigninFormData((prevData) => ({ ...prevData, email: user_email }));
    }
    hackTitle();
  }, []);

  const navigateTo = (path, userData = null) => {
    if (userData) {
      navigate(path, { state: { userData } });
    } else {
      navigate(path);
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const forgotPassword = () => {
    if (signinFormData.email.trim()) {
      navigate('/forgot-password', { state: { email: signinFormData.email.trim() } });
    }
    else {
      navigateTo('/forgot-password')
    }
  }

  const handleSignInInputChange = (e) => {
    const { name, value } = e.target;
    setSigninFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSignUpInputChange = (e) => {
    const { name, value } = e.target;
    setSignupFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const guestLogin = () => {
    // Fill in test user credentials
    setSigninFormData({
      email: 'testuser@gmail.com',
      password: 'testuser'
    });
    
    // Trigger form submission
    const form = document.getElementById('signin-form');
    form && form.dispatchEvent(new Event('submit', { cancelable: true }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
  
    try {
      setWaiting(true); // Start the spinner
  
      const formData = new FormData();
  
      if (isSignIn) {
        formData.append('email', signinFormData.email.trim());
        formData.append('password', signinFormData.password);
  
        const response = await fetch(`${serverHost}/signin`, {
          method: 'POST',
          body: formData,
        });
  
        const result = await response.json();
  
        if (response.status === 200) {
          sessionStorage.setItem('user_id', result.user_id);
          sessionStorage.setItem('username', result.username);
          sessionStorage.setItem('icon', result.icon);
          localStorage.setItem('ss_token', result.access_token);
          localStorage.setItem('ck_user_email', signinFormData.email.trim());
          navigateTo('/dashboard');
        } else {
          Swal.fire({
            title: 'Failed to sign in',
            text: result.error,
            icon: 'error',
            confirmButtonText: 'Close',
          });
        }
      } else {
        formData.append('name', signupFormData.name.trim());
        
        if (!signupFormData.name || signupFormData.name.trim().length < 6 || signupFormData.name.trim().length > 24) {
          Swal.fire({
            title: 'Failed to sign up',
            text: 'Username should be around 6-24 characters long',
            icon: 'error',
            confirmButtonText: 'Close',
          });
          return;
        }
        
        const validCharactersRegex = /^[a-zA-Z0-9_]*$/;
        if (!validCharactersRegex.test(signupFormData.name.trim())) {
          Swal.fire({
            title: 'Failed to sign up',
            text: 'Please use only letters, numbers, and underscores in your username',
            icon: 'error',
            confirmButtonText: 'Close',
          });
          return;
        }

        if (signupFormData.password.length < 6) {
          Swal.fire({
            title: 'Failed to sign up',
            text: 'Password should be atleast 6 characters long',
            icon: 'error',
            confirmButtonText: 'Close',
          });
          return;
        }

        formData.append('email', signupFormData.email);
  
        const response = await fetch(`${serverHost}/signup`, {
          method: 'POST',
          body: formData,
        });
  
        const result = await response.json();
  
        if (response.status === 200) {
          const userData = {
            name: signupFormData.name.trim(),
            email: signupFormData.email.trim(),
            password: signupFormData.password,
            otp_id: result.otp_id,
          };
  
          navigateTo('/verify-email', userData);
        } else {
          Swal.fire({
            title: 'Failed to sign up',
            text: result.error,
            icon: 'error',
            confirmButtonText: 'Close',
          });
        }
      }
    } catch (error) {
      Swal.fire({
        title: 'Failed to submit the form',
        text: error,
        icon: 'error',
        confirmButtonText: 'Close',
      });
    } finally {
      setWaiting(false); // Stop the spinner, whether successful or not
    }
  };

  const isMobile = window.matchMedia("(max-width: 600px)").matches;

  return (
    <Container>
      <LeftSide>
        <Logo src="images/storytelling.png" alt="Storytelling" />
        <Title>{title}</Title>
        <Subtitle>Because every story needs a listener <img src="images/care_emoji.png" alt="care" /></Subtitle>
      </LeftSide>
      <ReactCardFlip
        isFlipped={!isSignIn}
        flipDirection='horizontal'
        cardStyles={{
          front: {
            background: 'rgba(217, 217, 217, 0.5)',
            transform: `rotateY(${isSignIn ? '0deg' : '180deg'})`,
            transition: 'transform 1s ease',
            borderRadius: '5px',
            boxShadow: 'rgba(0, 0, 0, 0.2) -5px 5px 0px'
          },
          back: {
            background: 'rgba(217, 217, 217, 0.5)',
            transform: `rotateY(${isSignIn ? '180deg' : '0deg'})`,
            transition: 'transform 1s ease',
            borderRadius: '5px',
            boxShadow: 'rgba(0, 0, 0, 0.2) -5px 5px 0px'
          }
        }}
        containerStyle={{
          borderRadius: '5px',
          width: isMobile ? '90%' : 'auto',
          marginTop: isMobile ? '10%' : '0',
          marginBottom: isMobile ? '10%' : '0'
        }}
      >
        <>
          <Tabs>
            <Tab onClick={toggleForm} disabled={isSignIn}>
              Sign In
            </Tab>
            <Tab onClick={toggleForm} disabled={!isSignIn}>
              Sign Up
            </Tab>
          </Tabs>
          <ImageContainer>
            <img src="images/log-in.png" alt="Login Icon" />
          </ImageContainer>
          <FormContainer onSubmit={handleSubmit}>
            <Input
              type="email"
              placeholder="Email"
              required
              name="email"
              value={signinFormData.email}
              onChange={handleSignInInputChange}
              autoComplete="off"
            />
            <PasswordInputContainer>
              <PasswordInput
                type={showPassword ? 'text' : 'password'}
                placeholder="Password"
                required
                name="password"
                value={signinFormData.password}
                onChange={handleSignInInputChange}
                autoComplete="off"
              />
              <PasswordVisibilityButton onClick={togglePasswordVisibility}>
                {showPassword ? 'Hide' : 'Show'}
              </PasswordVisibilityButton>
            </PasswordInputContainer>
            <ForgotPasswordLink onClick={forgotPassword}>
              Forgot password?
            </ForgotPasswordLink>
            <SignInButton type="submit" disabled={waiting}>{waiting ? <i className='fa fa-spinner' />: 'Sign In'}</SignInButton>
          </FormContainer>
        </>
        <>
          <Tabs>
            <Tab onClick={toggleForm} disabled={isSignIn}>
              Sign In
            </Tab>
            <Tab onClick={toggleForm} disabled={!isSignIn}>
              Sign Up
            </Tab>
          </Tabs>
          <ImageContainer>
            <img src="images/signup.png" alt="Sign up Icon" style={{ width: isMobile ? '60%' : '100%', paddingBottom: '10px' }}/>
          </ImageContainer>
          <FormContainer onSubmit={handleSubmit}>
            <Input
              type="text"
              placeholder="Username"
              required
              name="name"
              value={signupFormData.name}
              onChange={handleSignUpInputChange}
              autoComplete="off"
            />
            <Input
              type="email"
              placeholder="Email"
              required
              name="email"
              value={signupFormData.email}
              onChange={handleSignUpInputChange}
              autoComplete="off"
            />
            <PasswordInputContainer>
              <PasswordInput
                type={showPassword ? 'text' : 'password'}
                placeholder="Password"
                required
                name="password"
                value={signupFormData.password}
                onChange={handleSignUpInputChange}
                autoComplete="off"
              />
              <PasswordVisibilityButton onClick={togglePasswordVisibility}>
                {showPassword ? 'Hide' : 'Show'}
              </PasswordVisibilityButton>
            </PasswordInputContainer>
            <SignInButton type="submit" style={{ marginBottom: '20px' }} disabled={waiting}>{waiting ? <i className='fa fa-spinner' />: 'Sign Up'}</SignInButton>
            <GuestLoginButton onClick={guestLogin} disabled={waiting}>{waiting ? <i className='fa fa-spinner' />: 'Guest Login'}</GuestLoginButton>
          </FormContainer>
        </>
      </ReactCardFlip>
    </Container>
  );
}

export default Home;

const Container = styled.main`
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 92vh;
  background-color: white;

  @media only screen and (max-width: 600px) {
    height: auto;
    flex-direction: column;
    justify-content: flex-start;
    overflow-y: hidden;
  }
`;

const LeftSide = styled.div`
  text-align: center;

  @media only screen and (max-width: 600px) {
    margin: 10% 0 0 0;
  }
`;

const Logo = styled.img`
  // max-width: 150px;

  @media only screen and (max-width: 600px) {
    // max-width: 20%; 
    display: none;
  }
`;

const Title = styled.h1`
  margin: 0;
  text-shadow: 3px 1.5px 0 #abdeb6;
  font-family: 'Space Mono', monospace;
  font-size: 4rem;
  padding: 10px 15px;
  border-radius: 10px;

  &:hover {
    background: #6559A2;
    color: white;
  }

  @media only screen and (max-width: 600px) {
    margin: 0; 
    font-size: 3rem;
  }
`;

const Subtitle = styled.p`
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 26px;
  color: #6559A2;
  font-style: italic;
  margin: 0 0;
  justify-content: center;
  img {
    height: 32px;
  }

  @media only screen and (max-width: 600px) {
    font-size: 18px; 
  }

`;

// const RightSide = styled.div`
//   padding: 20px;
//   border-radius: 5px;
//   box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
//   width: 20%;
//   background: rgba(217, 217, 217, 0.5);
//   position: relative;
// `;

const ImageContainer = styled.div`
  text-align: center;
  background: transparent;
  padding: 0 20px;
  img {
    background: transparent;
  }
`;

const Tabs = styled.div`
  display: flex;
  margin-bottom: 20px;
  width: 100%;
  min-height: 50px;
  background: #6559A2;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  justify-content: space-around;
  align-items: center;
`;

const Tab = styled.button`
  flex: 1;
  font-size: 14px;
  padding: 5px;
  max-width: 100px;
  background-color: #6559A2;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-right: 10px;

  &:last-child {
    margin-right: 0;
  }

  &:hover:enabled {
    // background-color: #fff;
    // color: #6559A2;
    font-size: 18px;
    transition: font-size 0.2s ease;
  }
  
  &:disabled {
    cursor: default;
    font-size: 24px;
  }
`;

const Input = styled.input``;

const ForgotPasswordLink = styled.a`
  // margin: 10px 0 0 5px;
  background: transparent;
  font-weight: bold;
  cursor: pointer;
  font-size: 14px;
`;

const SignInButton = styled.button`
  background-color: #6559a2;
  i {
    animation: rotation 2s infinite linear;
  }

  @keyframes rotation {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(359deg);
    }
  }
`;

const GuestLoginButton = styled.button`
  background-color: #74B72E;

  i {
    animation: rotation 2s infinite linear;
  }

  @keyframes rotation {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(359deg);
    }
  }
`;

const PasswordInputContainer = styled.div`
  position: relative;

  span {
    font-size: 14px;
    font-weight: bold;
    position: absolute;
    top: 25%;
    right: 10px;
    color: #6559A2;
    cursor: pointer;
  }
`;

const PasswordInput = styled.input`
  padding: 10px;
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 5px;
  margin-bottom: 10px;
`;

const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
  background: transparent;
  padding: 0 20px;
  padding-bottom: 20px;
  // transform: rotateY(180deg);

  input {
    margin-bottom: 10px;
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 4px;
  }

  a {
    color: #777;
    text-decoration: none;
    margin-bottom: 10px;
  }

  button {
    // margin-top: 25px;
    padding: 10px;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    box-shadow: rgba(0, 0, 0, 0.2) -3px 3px 0px;
  }
`;

const PasswordVisibilityButton = styled.span`
  font-size: 14px;
  font-weight: bold;
  position: absolute;
  top: 25%;
  right: 10px;
  color: #6559a2;
  cursor: pointer;
`;

const Disclaimer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  
  i {
    border-radius: 50%;
    border: 1px solid red;
    padding: 5px;
    color: red;
  }
  
  p {
    font-size: 15px;
  }
`;